<template>
  <component
    :is="comSubTypeList[comSubType]"
    :widgetId="widgetId"
    :refreshPeriod="refreshPeriod"
    ref="charts"
  ></component>
</template>

<script>
/*
   * 基本echart，柱状图，折线图以及饼图
   * */
import echartLine from './echarts-line'
import echartBar from './echarts-bar'
import echartPie from './echarts-pie'
export default {
  name: 'widget-filter',
  props: {
    widgetId: {
      type: String,
      default: () => {
        return ''
      }
    },
    comSubType: {
      type: String,
      default: () => {
        return ''
      }
    },
    refreshPeriod: {
      // 部件刷新周期
      type: Number,
      default: () => {
        return 0
      }
    }
  },
  data () {
    return {
      comSubTypeList: {
        'echarts-bar': 'echartBar',
        'echarts-line': 'echartLine',
        'echarts-circle': 'echartPie'
      }
    }
  },
  methods: {
    resizeChart () {
      this.$refs.charts.resizeEchart()
    }
  },
  components: {
    echartLine,
    echartBar,
    echartPie
  }
}
</script>

<style scoped lang="less" rel="stylesheet/less">
@import "~assets/styles/var.less";
@import "~assets/styles/mixin.less";
</style>
